import { Component, OnInit } from '@angular/core';
import { HeadlessView } from '../../../common/shared/components/headless-view';
import { LayoutService } from '../../../common/layout/layout.service';
import { MobileDetectorService } from '../../../common/shared/mobile-detector.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CreateMessageService } from '../create-message.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ListFilterService } from '../../../common/shared/list-filter.service';
import { NotificationService } from '../../../common/layout/notification.service';

@Component({
    selector: 'ns-choose-documents',
    templateUrl: './choose-documents.component.html',
    styleUrls: ['./choose-documents.component.scss']
})
export class ChooseDocumentsComponent extends HeadlessView implements OnInit {

    public documents;
    public documentsCopy;
    public myDocuments;
    public myDocumentsCopy;
    public searchForm: FormGroup;
    public model = {};
    public searchText = '';

    private subs: Subscription = new Subscription();

    constructor(
        protected layoutService: LayoutService,
        protected mobileDetectorService: MobileDetectorService,
        private activatedRoute: ActivatedRoute,
        private createMessageService: CreateMessageService,
        private router: Router,
        private formBuilder: FormBuilder,
        private listFilterService: ListFilterService,
        private notificationService: NotificationService,
    ) {
        super(layoutService, mobileDetectorService);

        this.documents = activatedRoute.snapshot.data['documents'];
        this.documentsCopy = JSON.parse(JSON.stringify(this.documents));
        this.myDocuments = activatedRoute.snapshot.data['myDocuments'];
        this.myDocumentsCopy = JSON.parse(JSON.stringify(this.myDocuments))

        this.searchForm = formBuilder.group({
            search: []
        });

        this.subs.add(
            this.searchForm.valueChanges.pipe(
                debounceTime(400)
            ).subscribe(data => {
                this.searchText = data.search;
                this.filterList(data.search);
            })
        );

        this.layoutService.disableFooter();
    }

    ngOnInit(): void {
    }

    ngOnDestroy() {
        super.ngOnDestroy();

        this.subs.unsubscribe();
    }

    public onGoBack() {
        this.router.navigate(['..'], { relativeTo: this.activatedRoute });
    }
    public onNext() {

        if (!Object.keys(this.model).length) {
            this.notificationService.error('Wybierz 1 lub więcej dokumentów');
            return;
        }

        this.createMessageService.saveDocumentsSelection(this.model);
        this.router.navigate(['..', 'wyslij'], { relativeTo: this.activatedRoute });
    }

    public filterList(searchText) {
        if (searchText) {
            this.documents.data = this.listFilterService.filterList(
                searchText,
                JSON.parse(JSON.stringify(this.documentsCopy.data)),
                (value, index) => {
                    if (value.documents) {
                        value.documents = value.documents.filter(doc => doc.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
                    }

                    return value.documents.length !== 0;
                }
            );

            // moja biblioteka
            this.myDocuments.data = this.listFilterService.filterList(
                searchText,
                JSON.parse(JSON.stringify(this.myDocumentsCopy.data)),
                (doc, index) => {
                    return doc.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
                }
            );
        } else {
            this.documents.data = JSON.parse(JSON.stringify(this.documentsCopy.data));
            this.myDocuments.data = JSON.parse(JSON.stringify(this.myDocumentsCopy.data));
        }
    }

    public downloadDocument(doc) {
        if (doc) {
            window.open('/api/files/' + doc.file.id, '_blank');
        }
    }

    public clearSearch() {
        this.searchForm.get('search').setValue('');
    }
}
